import { faAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import "./expand-collapse-arrows.scss";
import { IProps } from "./expand-collapse-arrows.types";

/**
 * Animated up/down arrow to open some content.
 * @param props.isUp Current state of the arrow.
 * @param props.onClick Function to call when the arrow is clicked.
 * @returns          Animated up/down arrow icon.
 */
const ExpandCollapseArrows = ({ isUp, onClick }: IProps) => {
    return (
        <div
            className={classNames("expand-collapse-arrow", { "expand-collapse-arrow--up": isUp })}
            onClick={onClick}
            role="button"
        >
            <FontAwesomeIcon icon={faAngleDown} />
        </div>
    );
};

export default ExpandCollapseArrows;
